export class StatusDto {
    /**
     * @type{number}
     */
    stId;

    /**
     * @type{string}
     */
    stName;

    /**
     * @type{int}
     */
    stSortSeq;

    /**
     * @type{Object<string, string>}
     */
    names;

    /**
     * @type{string[]}
     */
    manualLocales;

    constructor () {
        this.stId = 0;
        this.stName = '';
        this.stSortSeq = 0;
        this.names = {};
        this.manualLocales = [];
    }
}
